<template>
  <v-card>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form" @keyup.native.esc="close(400)" @keyup.native.ctrl.enter="processSave">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex v-show='view !== 3' xs12>
                  <v-radio-group v-model="editedItem.radio_type" row @change="changeType">
                    <v-radio label="Convidar por link " :value="1"></v-radio>
                    <v-radio label="Convidar usuários" :value="2"></v-radio>
                    <v-radio label="Usuário já cadastrado" :value="3"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-layout wrap v-if="editedItem.radio_type === 1">
                  <v-flex xs12 sm6 style="position:relative; padding-bottom:15px">
                    <v-tooltip top>
                      <v-text-field append-icon="file_copy" slot="activator" readonly :disabled="!companyParams['activeLink'] || !checkPlanAccess(entity, 'qtd', items.length, getAccesses)" name="link_register" id="link_register" label="Convidar por link" type="text" :value="createdLink ()" @click="copyLinkRegister" @click:append="copyLinkRegister"/>
                      <span>{{checkPlanAccess(entity, 'qtd', items.length, getAccesses) ? 'Clique para copiar' : 'Para usar o link faça o upgrade'}}</span>
                    </v-tooltip>
                    <v-checkbox class="ma-0" style="position:absolute; bottom:7px"  v-model="companyParams['activeLink']" @change="disableLink()" label="Habilitar registro por link" hide-details></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-else-if="editedItem.radio_type === 2">
                  <v-flex xs12>
                    <v-combobox
                      v-model="editedItem.emails"
                      :rules="emailManyRule('Acesso', true, true, 'email')"
                      label="Emails"
                      chips
                      clearable
                      multiple
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          @input="removeChip(data.item)"
                        >
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-autocomplete :label="translate('table.' + entity + '.field.access_id')" v-model="editedItem.access_id" :rules="requiredRule(translate('table.' + entity + '.field.access_id'))"
                                    name="access" :items="accesses" item-text="id_text" item-value="id" :filter="filterAutocomplete"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-switch :label="translate('table.' + entity + '.field.admin')"
                              v-model="editedItem.admin"></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-else>
                  <v-flex xs12>
                    <v-text-field v-if="view===3" label="Participante" disabled :value="`${editedItem.user.id_text} (${editedItem.user.email})`"></v-text-field>
                    <p-user-illis-system v-else ref="userIllisSystem" :itemsNotShow="itemsNotShow" v-model="editedItem.users" :rules="requiredManyRule('participante')">
                    </p-user-illis-system>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-autocomplete :label="translate('table.' + entity + '.field.access_id')" v-model="editedItem.access_id" :rules="requiredRule(translate('table.' + entity + '.field.access_id'))"
                                    name="access" :items="accesses" item-text="id_text" item-value="id" :filter="filterAutocomplete"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-switch :label="translate('table.' + entity + '.field.admin')"
                              v-model="editedItem.admin"></v-switch>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave">Salvar</v-btn>
          <v-btn class="mx-0" :loading="loading" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <p-company-user-duration ref="companyUserDuration"></p-company-user-duration>
    
    <v-card-title class="pa-0">
      <v-layout wrap justify-space-between align-center class="px-3">
        <v-flex xs6 sm4>
          <span class="headline">Participantes</span>
        </v-flex>
        <v-flex xs6 sm4>
          <v-form autocomplete="off" @submit.prevent="">
            <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
          </v-form>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-right">
          <p-btn-upgrade v-if="!checkPlanAccess(entity, 'qtd', items.length, getAccesses)"></p-btn-upgrade>
          <v-tooltip top>
            <v-btn slot="activator" color="primary" @click="create" :disabled="!checkPlanAccess(entity, 'qtd', items.length, getAccesses)">
              {{this.translate('system.button.add.title')}}
              <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
            </v-btn>
            <span>{{checkPlanAccess(entity, 'qtd', items.length, getAccesses) ? 'Adicionar Usuário' : 'Para incluir mais usuários faça o upgrade'}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text style="padding-top:0">
      <v-layout wrap justify-center align-center>
        <!--Dialog para confirmação de exclusão-->
        <p-confirm text="Ao excluir esse usuário, ele será removido das: tarefas, equipes e parcerias e suas recorrências serão excluídas. Tem certeza que deseja excluí-lo" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
        <!--Index-->
        <v-flex class="text-xs-right">
          <span><strong>{{ this.items.length }}</strong> usuários de <strong>{{this.getQtdPlan}}</strong></span>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :no-data-text="emptyTable"
            no-results-text="Nenhum usuário encontrado"
            rows-per-page-text="Registros por página"
            :headers="headers"
            :items="items"
            :search="search"
            hide-actions
            :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
            class="elevation-1"
            :custom-filter="customizedFilter">
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td style="word-break: break-all;">{{ props.item.user_id ? `${props.item.user.id_text} (${props.item.user.email})` : props.item.email}}</td>
              <td>{{ props.item.access.id_text}}</td>
              <td>
                <v-checkbox
                  v-model="props.item.admin" readonly
                ></v-checkbox>
              </td>
              <td>{{ translate('value.company_user_status').find((val) => {return val.value === props.item.status}).text }}</td>
              <td align="center" style="min-width: 200px">
                <v-tooltip bottom v-if="props.item.status === 2">
                  <v-btn slot="activator" icon @click="$refs.companyUserDuration.openDialog(`${props.item.user_id}-${props.item.company_id}`, props.item.user_id ?
                  `${props.item.user.id_text} (${props.item.user.email})` : props.item.email)" :disabled="!checkPermission('report_participant', 'view')" class="mx-0">
                    <v-icon color="orange">library_books</v-icon>
                  </v-btn>
                  <span>Relatorio</span>
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.status === 2">
                  <v-btn slot="activator" icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon class="mx-0" @click="dialogDelete(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>Excluir</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider v-if="showClose"></v-divider>
    <v-card-actions v-if="showClose" class="pa-0">
      <v-spacer></v-spacer>
      <v-btn color="primary" class="my-2 mr-4" @click.native="closeDialog()">FECHAR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PUserIllisSystem from './../shared/PUserIllisSystem'
  import PCompanyUserDuration from './../../components/reports/PCompanyUserDuration'
  import PBtnUpgrade from './../shared/PBtnUpgrade'
  import plan from './../../mixin/plan'

  export default {
    mixins: [crud, rules, plan],
    components: {
      PConfirm,
      PUserIllisSystem,
      PCompanyUserDuration,
      PBtnUpgrade
    },
    data: () => ({
      entity: 'company_user',
      itemsNotShow: [],
      access: [],
      companyParams: [],
      plan: [],
      participants: [],
      getAccesses: [],
      // Quantidade de usuários do plano
      getQtdPlan: [],
      accesses: [],
      loading: false
    }),
    name: 'User',
    props: {
      company: {
        type: Object,
        default: () => { return null }
      },
      notBroadcast: {
        type: Boolean,
        default: false
      },
      showClose: {
        type: Boolean,
        default: false
      }
    },
    // A props notBroadcast define se o componente e usado da empresa ou dos usuarios da empresa, para definir se o socket funcionara para a propria pagina ou nao (Isso ocorre caso o usuario esteja na tela de gerenciamento de empresa e abra o "Usuarios da Empresa"
    created () {
      this.participants = this.company.participants
      this.accesses = this.company.get_accesses_company
      this.plan = this.company.get_plan_user
      this.getAccesses = JSON.parse(this.plan.accesses)
      this.items = this.company.users
      this.companyParams = JSON.parse(this.company.params)
      this.checkQtdAccess(this.entity, this.items.length, false, this.getAccesses)
      this.getQtdPlan = this.getAccesses.find((res) => {
        return (res.id_text === this.entity && res.hasOwnProperty('qtd'))
      })
      this.getQtdPlan = this.getQtdPlan ? this.getQtdPlan['qtd'] : 'Ilimitado'
      this.editedItem = {company_id: this.company.id, user_id: null, admin: 0, status: 1, radio_type: 1, emails: [], users: [], link: ''}
      this.defaultItem = {company_id: this.company.id, user_id: null, admin: 0, status: 1, radio_type: 1, emails: [], users: [], link: ''}
      this.createdLink()
    },
    methods: {
      // EM TODAS CHAMADAS DE SOCKET SEJAM PARA TRATAMENTO DE EXCLUSÃO EDIÇÃO E ADIÇÃO SÃO REALIZADAS DUAS, UMA PARA QUEM ESTÁ NA TELA DE GERENCIAMENTO DA EMPRESA, E A OUTRA PARA QUEM A ACESSOU ATRAVES DO MENU PRINCIPAL "Participantes da Empresa", FOI CRIADO O SOCKET SEPARADO POIS O DO MENU PRINCIPAL SEMPRE FICAVA ATIVO E ACABA ATRAPALHANDO OS DEMAIS.
      processSave () {
        if (this.view >= 3) {
          this.save()
          return
        }
        if ((this.$refs.form && !this.$refs.form.validate()) || (this.$refs.userIllisSystem && !this.$refs.userIllisSystem.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if (this.editedItem.radio_type === 3) {
          if (!this.checkPlanAccess(this.entity, 'qtd', (this.items.length + this.editedItem.users.length) - 1, this.getAccesses)) {
            this.$store.commit('snackbar/change_values', {
              text: 'A quantidade de usuários ultrapassa o limite de seu plano! Para incluir mais faça upgrade',
              color: 'warning',
              dialog: true
            })
            return false
          }
          this.$store.commit('loader/change_dialog', true)
          this.loading = true
          this.$http.post('api/' + this.entity, this.editedItem).then(
            (res) => {
              res.body.forEach((newUser) => {
                this.items.push(JSON.parse(JSON.stringify(newUser)))
                this.afterInsert(newUser)
              })
              this.close(0)
              this.loading = false
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ' incluído com sucesso!',
                color: 'success',
                dialog: true
              })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível incluir o registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ', reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
        } else {
          if (!this.checkPlanAccess(this.entity, 'qtd', (this.items.length + this.editedItem.emails.length) - 1, this.getAccesses)) {
            this.$store.commit('snackbar/change_values', {
              text: 'A quantidade de usuários ultrapassa o limite de seu plano! Para incluir mais faça upgrade',
              color: 'warning',
              dialog: true
            })
            return false
          }
          this.$store.commit('loader/change_dialog', true)
          this.loading = true
          this.$http.post(`api/${this.entity}`, this.editedItem).then((res) => {
            res.body.forEach((newUser) => {
              if (newUser.type !== 3) { // Se o novo participante já for cadastrado no sistema, adicionamos a empresa à sua tela de consulta
                let asyncCompany = JSON.parse(JSON.stringify(this.company))
                asyncCompany.user = [
                  {
                    'admin': newUser.admin,
                    'company_id': newUser.company_id,
                    'id': newUser.id,
                    'status': newUser.status,
                    'user_id': newUser.user_id
                  }]
                // Socket enviado para adicionar a empresa nos usuários que foram inseridos
                this.$socket.emit('generalEvent', {
                  data: asyncCompany,
                  responseEvent: 'addSocketItem',
                  room: `companies${newUser.user_id}`
                })
              }
            })
            let users = res.body.filter((val) => { return val.type !== 1 })
            var _this = this
            users.map(function (user) {
              _this.items.push(user)
              // o Socket é para inserir os usuários na empresa ( Gerenciamento de Empresa)
              _this.$socket.emit('generalDetailsEvent', {
                data: user,
                details: 'users',
                notBroadcast: _this.notBroadcast,
                responseEvent: 'addSocketDetails',
                room: `companies${_this.editedItem.company_id}_manage` // * Tela de gerenciamento
              })
              // o Socket é para inserir os usuários na empresa (Participantes da Empresa)
              _this.$socket.emit('generalDetailsEvent', {
                data: user,
                details: 'users',
                responseEvent: 'addSocketDetailsCompanyUser',
                room: `companies${_this.editedItem.company_id}_manage` // * Tela de gerenciamento
              })
            })
            this.close(0)
            this.loading = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: `Registro de ${this.translate(`table.${this.entity}.title`)[0]} incluído com sucesso!`,
              color: 'success',
              dialog: true
            })
          })
        }
      },
      // Função que vai criar o codigo de convite.
      createdLink () {
        let values = `||${this.editedItem.company_id}|0|`
        let encoded = btoa(values)
        return `https://${window.location.hostname}/#/register/${encoded}`
      },
      copyLinkRegister () {
        var copyText = document.getElementById('link_register')
        /* Select the text field */
        copyText.select()
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999)
        /* Copy the text inside the text field */
        setTimeout(() => {
          document.execCommand('copy')
          this.$store.commit('snackbar/change_values', { text: `Link copiado para sua área de transferência!`, color: 'success', dialog: true })
        }, 200)
      },
      beforeCreate () {
        this.itemsNotShow = []
        this.items.map((item) => {
          this.itemsNotShow.push(item.user_id)
        })
      },
      beforeEditItem (item, view) {
        // quando edita muda para o radio 3 para abrir a tela de edição com os campos corretos do usuário
        this.editedItem.radio_type = 3
      },
      afterInsert (newValues) {
        this.checkQtdAccess(this.entity, this.items.length, true, this.getAccesses)
        // Refaz o filtro depois que insere
        this.redoFilter(this.items)
        // Evento que irá adicionar o participante à lista de participantes da empresa que estão na tela de gerenciamento.
        this.$socket.emit('generalDetailsEvent', {
          data: newValues,
          details: 'users',
          notBroadcast: this.notBroadcast,
          responseEvent: 'addSocketDetails',
          room: `companies${this.company.id}_manage` // * Tela de gerenciamento
        })
        this.$socket.emit('generalDetailsEvent', {
          data: newValues,
          details: 'users',
          responseEvent: 'addSocketDetailsCompanyUser',
          room: `companies${this.company.id}_manage` // * Tela de gerenciamento
        })
        // Evento que irá adicionar o convite de empresa à tela de consulta do novo participante com opções de aceitar ou não.
        let asyncCompany = JSON.parse(JSON.stringify(this.company))
        asyncCompany.user = [
          {
            'admin': newValues.admin,
            'company_id': newValues.company_id,
            'id': newValues.id,
            'status': newValues.status,
            'user_id': newValues.user_id
          }]
        if (newValues.status === 1) {
          this.$socket.emit('generalEvent', {
            data: asyncCompany,
            responseEvent: 'addSocketItem',
            room: `companies${newValues.user_id}` // Evento será enviado somente para a sala de empresas do novo usuário para incluir a empresa para o novo usuario
          })
        }
      },
      beforeUpdate (item) {
        // A verificação deve ser feito independente do status do usuário alterado, de forma a garantir que: 1) o único usuário Admin alterado não recebeu
        // admin = false; 2) o único usuário Admin alterado não foi alterado pra outro usuário, alterando assim seu status para aguardando - é preciso ao menos um Admin Aceito
        if (item.admin === false) {
          let response = this.items.some((user) => {
            return ((user.admin === 1 || user.admin === true) && (user.id !== item.id) && (user.status === 2))
          })
          if (!response) {
            this.$store.commit('snackbar/change_values', {text: 'É requerido no mínimo um Administrador!', color: 'error', dialog: true})
            return false
          }
        }
        // É pego o acesso alterado para ser usado no afterUpdate, pos no afterUpdate o editedItem já está zerado
        this.access = this.accesses.find((val) => { return val.id === this.editedItem.access_id })
      },
      afterUpdate (newValues, oldValues) {
        // * Montando o objeto "user" que será enviado para o novo usuário juntamente com informações da empresa pois esses dados são importantes
        // * para a adição do convite da empresa na tela do novo participante. OBS.: Objeto é montado no front ao invés de buscar os dados
        // * no banco de dados, pois foi decidido juntamente com @RafaelBMD que essa seria a opção mais viável e de menor custo computacional.
        let asyncCompany = JSON.parse(JSON.stringify(this.company))
        asyncCompany.user = [
          {
            'admin': newValues.admin,
            'company_id': newValues.company_id,
            'id': newValues.id,
            'status': newValues.status,
            'user_id': newValues.user_id
          }]
        // * Evento emitido para atualizar os detalhes para os participantes da empresa que estiverem na tela de gerenciamento.
        this.$socket.emit('generalDetailsEvent', {
          data: newValues,
          details: 'users',
          notBroadcast: this.notBroadcast,
          responseEvent: 'editSocketDetails',
          room: `companies${newValues.company_id}_manage` // * Tela de gerenciamento
        })
        // * Evento emitido para atualizar os detalhes para os participantes da empresa que estiverem na tela de "Participantes da Empresa" do IN.
        this.$socket.emit('generalDetailsEvent', {
          data: newValues,
          details: 'users',
          responseEvent: 'editSocketDetailsCompanyUser',
          room: `companies${newValues.company_id}_manage` // * Tela de gerenciamento
        })
        // * Evento emitido enviando os dados do participante editado da empresa para que, neste caso, sejam atualizadas as permissões do participante na tela de consulta.
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'generalSocket',
          room: `companies${newValues.user_id}`
        })
        // * verificamos se foi alterado somente o privilégio de administrador dele
        if (newValues.admin !== oldValues.admin) {
          this.$socket.emit('generalEvent', {
            data: {text: `Você não é mais administrador da empresa "${newValues.company.id_text}". Será necessário recarregar a página.`, user_id: newValues.user_id},
            responseEvent: 'deleteSocketDetailUser',
            room: `companies${newValues.company_id}_manage`
          })
          this.$socket.emit('generalEvent', {
            data: {text: `Você não é mais administrador da empresa "${newValues.company.id_text}". Será necessário recarregar a página.`, user_id: newValues.user_id},
            responseEvent: 'deleteSocketDetailUserCompanyUser',
            room: `companies${newValues.company_id}_manage`
          })
        }
        // * Verificamos se há alteração de acesso do usuário para atualizarmos as permissões do sistema de acordo com o novo acesso.
        if (newValues.access_id !== oldValues.access_id) {
          this.$socket.emit('generalEvent', {
            data: newValues.access,
            notBroadcast: true,
            responseEvent: 'changePermissions',
            room: `user${newValues.user_id}`
          })
        }
        // foi guarda o id do usuario editado para ser verificado se é do usuário logado
        let userId = this.beforeEditedItem.user_id
        let access = JSON.parse(JSON.stringify(this.access))
        // Modifica o accesso caso seja alterado o acesso do usuário logada
        if (this.$auth.user().id === userId) {
          access.permissions = JSON.parse(this.access.permissions)
          this.$store.commit('access/change_value', access)
        }
        this.access = []
      },
      beforeDelete (item) {
        if (item.admin === true || item.admin === 1) {
          let response = true
          this.items.map(function (user) {
            if ((user.admin === 1 || user.admin === true) && (user.id !== item.id) && (user.status === 2)) {
              response = false
            }
          })
          if (response) {
            this.$store.commit('snackbar/change_values', {text: 'É requerido no mínimo um Administrador!', color: 'error', dialog: true})
            return false
          }
        }
      },
      afterDelete (oldValues) {
        // Enviando evento de exclusão do participante da empresa, para os usuários que estão na tela de gerenciamento.
        this.$socket.emit('generalDetailsEvent', {
          data: oldValues,
          notBroadcast: this.notBroadcast,
          details: 'users',
          responseEvent: 'deleteSocketDetails',
          room: `companies${oldValues.company_id}_manage` // * Tela de gerenciamento
        })
        this.$socket.emit('generalDetailsEvent', {
          data: oldValues,
          details: 'users',
          responseEvent: 'deleteSocketDetailsCompanyUser',
          room: `companies${oldValues.company_id}_manage` // * Tela de gerenciamento
        })
        // Enviando evento de exclusão da empresa, para o usuário que está na tela de consulta e deixou de ser o participante da empresa.
        // OBS.: Evento será enviado somente caso o convite ainda esteja pendente ou se o usuário já tiver aceito o convite.
        if (oldValues.status !== 3) {
          this.$socket.emit('generalEvent', {
            data: this.company,
            responseEvent: 'deleteSocketItem',
            room: `companies${oldValues.user_id}`
          })
        }
        // Os dois próximos eventos têm a função de mostrar uma alerta na tela do usuário em uma situação em que ele é removido de uma empresa.
        // Podemos ter dois cenários:
        // 1 - Se o usuário removido estiver logado na empresa, o alerta deve ser mostrado imediatamente em qualquer parte do sistema. Este evento
        // é recebido no arquivo "In.vue" e então é feita a verificação para confirmar se ele está logado na empresa, se sim mostramos o alerta.
        this.$socket.emit('generalEvent', {
          data: {text: `Você foi removido da empresa "${oldValues.company.id_text}". Será necessário recarregar a página.`, company_id: oldValues.company_id},
          notBroadcast: true,
          responseEvent: 'deleteSocketCompany',
          room: `user${oldValues.user_id}`
        })
        // 2 - Se o usuário removido não estiver logado na empresa excluída mas estiver gerencianto/editando essa companhia, o alerta também deve
        // ser mostrado a ele pois não é possível gerenciar ou editar uma empresa se não for participante. Então enviamos este evento para os
        // usuários que estiverem na tela de gerenciamento. Ele também é recebido no arquivo "In.vue" e lá é feita a verificação se o usuário que recebeu
        // é o usuário removido da empresa, se sim mostramos o alerta.
        this.$socket.emit('generalEvent', {
          data: {text: `Você foi removido da empresa "${oldValues.company.id_text}". Será necessário recarregar a página.`, user_id: oldValues.user_id},
          notBroadcast: true,
          responseEvent: 'deleteSocketDetailUser',
          room: `companies${oldValues.company_id}_manage` // * Tela de gerenciamento
        })
        this.$socket.emit('generalEvent', {
          data: {text: `Você foi removido da empresa "${oldValues.company.id_text}". Será necessário recarregar a página.`, user_id: oldValues.user_id},
          notBroadcast: true,
          responseEvent: 'deleteSocketDetailUserCompanyUser',
          room: `companies${oldValues.company_id}_manage` // * Tela de gerenciamento
        })
      },
      changeType (val) {
        this.$refs.form.resetValidation()
        this.editedItem.user_id = null
        this.editedItem.emails = []
      },
      removeChip (item) {
        this.editedItem.emails.splice(this.editedItem.emails.indexOf(item), 1)
        this.editedItem.emails = [...this.editedItem.emails]
      },
      closeDialog () {
        this.$emit('closeDialog')
      },
      disableLink () {
        let companyId = this.company ? this.company['id'] : this.$auth.user().company_id
        this.$http.put('api/companies/' + companyId, {params: JSON.stringify(this.companyParams)}).then((res) => {
          // joga o valor de volta para os parametros na empresa
          this.$emit('input', JSON.stringify(this.companyParams))
          this.$socket.emit('generalEvent', {
            data: this.companyParams,
            responseEvent: 'changeCompanyParams',
            room: `user${this.$auth.user().id}`
          })
          this.$store.commit('snackbar/change_values', {
            text: 'Compartilhamento do link alterado com sucesso.',
            color: 'success',
            dialog: true
          })
        }, (err) => {
          console.log(err)
          this.companyParams['activeLink'] = !this.companyParams['activeLink']
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível editar o registro, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate(`table.${this.entity}.field.user_id`), value: 'user.id_text', width: '40%'},
          {text: this.translate(`table.${this.entity}.field.access_id`), value: 'user.access.id_text', width: '40%'},
          {text: this.translate(`table.${this.entity}.field.admin`), value: 'admin', width: '5%'},
          {text: this.translate(`table.${this.entity}.field.status`), value: 'status', width: '10%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/CompanyUser.vue